import { ITeamsDriversCards, TeamsDriversCards } from '@sky-it-livedata/livedata-sports-design-system';
import { WidgetContext } from "../../types/WidgetContext";
import { TeamDriverPageQuery } from "./types";
import transformQuery from "./transformers/query-transformer";
import { log } from "../../utils/log";
import { useIntcmp } from '../../hooks/useIntcmp';

export const setCustomAttributes = ({
  variables,
}: WidgetContext<TeamDriverPageQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<TeamDriverPageQuery>): ITeamsDriversCards => {
  return transformQuery(props);
}

const ResultsContainer = ({
  props,
  ...rest
}: WidgetContext<ITeamsDriversCards>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
      <TeamsDriversCards {...props} />   
    </div>
)
};

export default ResultsContainer;